import React from "react";
import "./WaterSection.css";

import waterImage from "../Assets/images/waterbody.jpg";

const WaterSection = () => {
  return (
    <section className="water-section">
      <div className="water-container">

        {/* Section Header */}
        <div className="water-header">
          <h2>If we protect our water, we protect our future.</h2>
          <p className="water-subtitle">
            “We are running for health…<br />
            But some children are walking for water.”
          </p>
        </div>

        {/* Image */}
        <div className="water-image">
          <img src={waterImage} alt="Children collecting water" />
        </div>

      </div>
    </section>
  );
};

export default WaterSection;